import type {
  Question,
  QuestionAnswer,
  QuestionAnswerLog,
} from '@pbt/pbt-ui-components'

export const hasSelectedAnswers = (answers: QuestionAnswer[]) =>
  answers.some((answer) => answer.selected)

export const hasQuestionWithSelectedAnswer = (questions: Question[]) =>
  questions.some(({ answers }) => hasSelectedAnswers(answers))

export type QuestionLog = Question & { answers: QuestionAnswerLog[] }

export const flattenFollowUpQuestions = (
  questions: QuestionLog[],
): QuestionLog[] => {
  const result: QuestionLog[] = []
  const followUpQuestions: QuestionLog[] = []

  questions.forEach((question) => {
    const processedQuestion: QuestionLog = {
      ...question,
      answers: question.answers.map((answer: QuestionAnswerLog) => {
        if (answer.followUpQuestionLog) {
          const followUp = answer.followUpQuestionLog
          followUpQuestions.push(followUp)
          return {
            ...answer,
            followUpQuestionLog: null,
          }
        }
        return answer
      }),
    }

    result.push(processedQuestion)
  })

  if (followUpQuestions.length > 0) {
    const flattenedFollowUps = flattenFollowUpQuestions(followUpQuestions)
    result.push(...flattenedFollowUps)
  }

  return result
}
